import { useSearchParams, Link } from 'react-router-dom';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconAlert from '../../../components/common/IconAlert';

const WalletPayment = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const rawRefId = searchParams.get('ref_id');
  const refId =
    rawRefId && rawRefId !== 'null' && rawRefId !== 'undefined'
      ? rawRefId
      : null;

  return (
    <div className="px-md-6 py-4">
      <Card className="p-4">
        {status === 'ok' && (
          <IconAlert variant="success" className="mb-0">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-column">
                <span className="fw-semi-bold">شارژ کیف پول با موفقیت انجام شد.</span>
                <span className="mt-1 fs--1">
                  مبلغ پرداختی به موجودی کیف پول شما اضافه شد و از همین حالا قابل
                  استفاده است.
                </span>
                {refId && (
                  <span className="mt-2 fs--1 text-700">شناسه پیگیری: {refId}</span>
                )}
              </div>
              <Link to="/" className="w-100 w-lg-auto mt-3 mt-lg-0">
                <Button
                  variant="falcon-primary"
                  className="w-100 d-flex justify-content-center align-items-center w-lg-auto mt-3 mt-lg-0 fs--1"
                >
                  <FontAwesomeIcon className="me-1" icon="pie-chart" />
                  ورود به داشبورد
                </Button>
              </Link>
            </div>
          </IconAlert>
        )}

        {status === 'nook' && (
          <IconAlert variant="danger" className="mb-0">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-column">
                <span className="fw-semi-bold">شارژ کیف پول انجام نشد</span>
                <span className="mt-1 fs--1">
                  پرداخت تکمیل نشد و مبلغی از حساب شما کسر نشده است. در صورت تمایل
                  می‌توانید دوباره شارژ کنید.
                </span>
              </div>
              <Link to="/" className="w-100 w-lg-auto mt-3 mt-lg-0">
                <Button
                  variant="falcon-primary"
                  className="w-100 d-flex justify-content-center align-items-center w-lg-auto mt-3 mt-lg-0 fs--1"
                >
                  <FontAwesomeIcon className="me-1" icon="pie-chart" />
                  بازگشت به داشبورد
                </Button>
              </Link>
            </div>
          </IconAlert>
        )}
      </Card>
    </div>
  );
};

export default WalletPayment;
